import "./infoModal.css"
import { Box, Grow, Modal, Skeleton, Typography } from "@mui/material"
import { getIcon } from "../../../../src/utils/iconConfig"
import ArticleComponent from "./ArticleComponent"
import { useGlobalContext } from "../../../context/GlobalContext"
import RestrictedCard from "../cards/restrictedCard/RestrictedCard"
import designImage from "../../../assets/images/Frame 55 1 1.png"
import apiClient from "../../../lib/api_client"
import { useQuery } from "@tanstack/react-query"
import { useGatiRestrictData } from "./api/infoApi"
import SkeletonRestrictCard from "./components/SkeletonRestrictCard"

const InfoModal = ({ type, headLabel, Open, handleClose, restrictModal }) => {
  const karatHeader = ["Gold karat", "Diamond Quality", "Rhodium"]
  const { cartData } = useGlobalContext()

  const processCartData = (cartData) => {
    const goldSummary = {}
    const diamondSummary = {}
    const rhodiumSummary = {}

    cartData?.forEach((item) => {
      item?.quantityData?.forEach((qtyItem) => {
        const goldKey = `${qtyItem?.goldQty}-${qtyItem?.goldColor}`
        goldSummary[goldKey] = (goldSummary[goldKey] || 0) + 1

        if (qtyItem.diaQty) {
          diamondSummary[qtyItem.diaQty] =
            (diamondSummary[qtyItem.diaQty] || 0) + 1
        }

        if (qtyItem.rhodium) {
          rhodiumSummary[qtyItem.rhodium] =
            (rhodiumSummary[qtyItem.rhodium] || 0) + 1
        }
      })
    })

    return {
      "Gold karat": Object.entries(goldSummary).map(([key, count]) => {
        const [goldQty, goldColor] = key.split("-")
        return {
          GoldQuantity: `${goldQty}K`,
          goldColor,
          ArticleCount: count,
        }
      }),
      "Diamond Quality": Object.entries(diamondSummary).map(
        ([quality, count]) => ({
          "Diamond Quality": quality,
          ArticleCount: count,
        })
      ),
      Rhodium: Object.entries(rhodiumSummary).map(([rhodium, count]) => ({
        rhodium,
        ArticleCount: count,
      })),
    }
  }

  const ArticleData = processCartData(cartData)

  const { data: restrictedData = [], isLoading } = useGatiRestrictData({
    type: "restrict",
    orderId: restrictModal?.data?.orderNumber,
    Open,
  })

  let content

  switch (type) {
    case "Summary": {
      content = (
        <>
          <div className="karat-style">
            {karatHeader?.map((item, index) => (
              <div key={index}>
                <h3 className="karat-header">{item}</h3>
                <div className="karat-body">
                  <ArticleComponent
                    ArticleData={ArticleData[item]}
                    type={item}
                    handleClose={handleClose}
                  />
                </div>
              </div>
            ))}
          </div>
        </>
      )
      break
    }
    case "restrict": {
      content = (
        <>
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              gap: "0.8vw",
              maxHeight: "15vw",
              overflowY: "auto",
            }}>
            {/* {restrictData.map((data, i) => {
              return <RestrictedCard data={data} index={i} />
            })} */}

            {isLoading ? (
              Array.from({ length: 3 }).map((_, i) => <SkeletonRestrictCard />)
            ) : restrictedData.length === 0 ? (
              <Typography
                sx={{
                  color: "#191818",
                  fontSize: "18px !important",
                  fontFamily: "Poppins",
                  margin: "0px auto",
                }}>
                No Restricted Data
              </Typography>
            ) : (
              restrictedData.map((data, i) => (
                <RestrictedCard
                  key={data.styleNumber}
                  data={data}
                  index={i}
                  allData={restrictedData}
                />
              ))
            )}
          </div>
        </>
      )
      break
    }
  }

  return (
    <Modal
      open={Open}
      onClose={handleClose}
      sx={{ display: "flex", justifyContent: "center" }}>
      <Grow in={Open}>
        <Box className="summary-container" marginX="auto">
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            mb="1.2vw">
            <Box sx={{ display: "flex", alignItems: "center", gap: ".25vw" }}>
              <Typography className="search-modal-title">
                {headLabel}
              </Typography>
            </Box>
            <Box
              className="modal-close"
              sx={{ cursor: "pointer" }}
              onClick={() => handleClose()}>
              {getIcon("Cross")}
            </Box>
          </Box>
          <Box>{content}</Box>
        </Box>
      </Grow>
    </Modal>
  )
}

export default InfoModal
